<template>
    <div class="dispatcher-layout-wrapper">
        <EonTabMenu :leftItems="menuLeftItems" :rightItems="menuRightItems"/>
        <div class="with-tab-menu-body">
            <router-view class="dispatcher-layout-body"/>
        </div>
    </div>
</template>

<script>
    import EonTabMenu from "@/components/form/EonTabMenu";

    export default {
        name: "LayoutDispatcher",
        components: {EonTabMenu},
        data() {
            return {
                myHeight: "",
                menuLeftItems: [
                    {
                        label: "Planowane wyłączenia (moje)",
                        to: "/master/planned-my",
                    },
                    {
                        label: "Planowane wyłączenia (wszystkie)",
                        to: "/master/planned-all",
                    },
                ],
                menuRightItems:
                    [
                        {
                            icon: "pi pi-user",
                            label: "Moje konto",
                            to: "/master/user/profile",
                        },
                        {
                            label: "Wyloguj",
                            icon: "pi pi-sign-out",
                            to: "/login",
                            onClick: this.logout,
                        },
                    ],
            };
        },
        methods: {
            logout() {
                localStorage.removeItem("token");
                localStorage.removeItem("userId");
                localStorage.removeItem("role");
                localStorage.removeItem("fullName");
                localStorage.removeItem("area");
                localStorage.removeItem("email");
                localStorage.removeItem("phone");
            },
        },
        mounted() {
            if (!localStorage.getItem("token")) {
                this.$router.push({name: "login"});
            }
        },
    };
</script>

<style lang="less" scoped>
    @import "../assets/less/layout-admin.less";
    @import "../assets/less/view-with-tab-menu.less";

    .dispatcher-layout-wrapper {
        height: 100%;
        display: flex;
        flex-flow: column;
    }

    .dispatcher-layout-body {
        flex-grow: 1;
    }
</style>
